import { Fraction } from 'bi-fraction';
import { AGENTFUN_TAX } from '../constants';
export const getAgentfunRemainingForGrad = ({ gradThreshold, agentfunCurrent, bondingCurrent, }) => {
    const deltaY = agentfunCurrent
        .mul(bondingCurrent.sub(gradThreshold))
        .div(gradThreshold);
    return deltaY.div(Fraction.ONE.sub(AGENTFUN_TAX));
};
